export const environment = {
    production: true,
    wssEndpoint: 'wss://app.ondasat.com.py/websocket/OndaTrackServices/realtime',
    reportsEndPoint: 'https://app.ondasat.com.py/ws/OndaTrackServices/',
    baseURL: 'https://app.ondasat.com.py/ws/OndaTrackServices/webresources/',
    kmlURL: 'https://app.ondasat.com.py/ws/OndaTrackServices/',
    image: 'https://app.ondasat.com.py/ws/OndaTrackServices/image/',
    logo: 'assets/layout/images/login/logo-py.png',
    googleMapsApiKey: 'AIzaSyCdnjRgOmzKEM_2N7jVbHyjdnl5vCll28E',
    monitoringURL: 'https://app.ondasat.com.py/#/monitoring?token='
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts